import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "../../../../messages";
import useBuyoutStyles from "../../../../BuyoutStyles";
import SlideinOverlay from "../SlideinOverlay";
import EmailSentConfirmation from "./EmailSentConfirmation";
import EmailForm from "./EmailForm";
import CloseIcon from "@material-ui/icons/Close";
const EmailSlidein = ({ open, onClose, applicationNumber, paymentInfo }) => {
    const classes = useBuyoutStyles();
    const [email, setEmail] = useState("");
    const [emailSent, setEmailSent] = useState(false);
    const intl = useIntl();
    return (_jsxs(SlideinOverlay, { open: open, onClose: onClose, classes: classes, children: [_jsx(Typography, { className: classes.slideinTitle, children: intl.formatMessage(messages.emailSendCopy) }), emailSent ? (_jsx(EmailSentConfirmation, { email: email, onClose: onClose, classes: classes })) : (_jsxs(_Fragment, { children: [_jsx(EmailForm, { email: email, setEmail: setEmail, setEmailSent: setEmailSent, onClose: onClose, classes: classes, applicationNumber: applicationNumber, paymentInfo: paymentInfo }), _jsx(Button, { startIcon: _jsx(CloseIcon, {}), className: classes.closeButton, onClick: onClose, children: intl.formatMessage(messages.slideinClose) })] }))] }));
};
export default EmailSlidein;
//# sourceMappingURL=EmailSlidein.js.map